import React from 'react';
import { useLocation } from 'react-router-dom';
import { Navigate, Outlet } from 'react-router-dom';
import { useUserContext } from '../contexts/UserContext';

const ProtectedRoute = () => {
    const { userData } = useUserContext();
    const location = useLocation();
    console.log(userData);

    if (!userData) {
        return <Navigate to="/login" state={{ from: location }} />;
    }

    if (userData.resetPassword && location.pathname !== "/resetPassword") {
        return <Navigate to="/resetPassword" />;
    }

    return <Outlet />;
};

export default ProtectedRoute;